<template>
  <v-flex
    xs12
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
        md4
        offset-md1
      >
        <h3 class="title font-weight-regular pt-3">
          {{ $t('General Tax Settings') }}
        </h3>
        <v-flex class="pl-0">
          <span
            class="caption"
          >
            {{ $t('Apply tax behaviour for whole store') }}
          </span>
        </v-flex>
        <v-flex class="pl-0 pt-1">
          <span class="caption">
            {{ $t('The "Discount After Tax" switch determines whether the discount should be applied to the subtotal after taxes have been added to the subtotal') }}
          </span>
        </v-flex>
        <v-flex class="pl-0 pt-1">
          <span class="caption error--text">
            {{ $t('Changing these settings requires products and shipping methods reindex.') }}
          </span>
        </v-flex>
      </v-flex>
      <v-flex
        xs12
        md6
      >
        <v-card
          flat
          class="pa-3"
        >
          <v-select
            v-model="settings.type"
            :items="['sales', 'vat']"
            :label="$t('Tax Type')"
            outline
          />
          <v-switch
            v-model="settings.discount_after_tax"
            :label="$t('Discount After Tax')"
            class="mt-0"
          />
          <v-btn
            @click="updateGeneral"
          >
            {{ $t('Update') }}
          </v-btn>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
        md4
        offset-md1
      >
        <h3 class="title font-weight-regular pt-3">
          {{ $t('General VAT Settings') }}
        </h3>
        <v-flex class="pl-0">
          <span
            class="caption"
          >
            {{ $t('Apply VAT behaviour for whole store') }}
          </span>
        </v-flex>
        <v-flex class="pl-0 pt-1">
          <span class="caption">
            {{ $t('The "VAT in Price" switch determines whether the product price already has VAT included, or whether the system needs to add the VAT to it.') }}
          </span>
        </v-flex>
        <v-flex class="pl-0 pt-1">
          <span class="caption error--text">
            {{ $t('Changing these settings requires products and shipping methods reindex.') }}
          </span>
        </v-flex>
      </v-flex>
      <v-flex
        xs12
        md6
      >
        <v-card
          flat
          class="pa-3"
        >
          <v-switch
            v-model="settings.vat_in_price"
            :label="$t('VAT in Price')"
            :disabled="settings.type !== 'vat'"
            class="mt-0"
          />
          <v-btn
            :disabled="settings.type !== 'vat'"
            @click="updateVat"
          >
            {{ $t('Update') }}
          </v-btn>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
        md4
        offset-md1
      >
        <h3 class="title font-weight-regular pt-3">
          {{ $t('Sales Tax Settings') }}
        </h3>
        <v-flex class="pl-0">
          <span
            class="caption"
          >
            {{ $t('Apply sales tax behaviour for whole store') }}
          </span>
        </v-flex>
        <v-flex class="pl-0 pt-1 caption">
          {{ $t('Source options:') }}
          <ul>
            <li>{{ $t('"origin" uses store address to calculate taxes') }}</li>
            <li>{{ $t('"destination" uses shipping address to calculate taxes. If the shipping type for the order is pickup, then use the store address.') }}</li>

          </ul>
        </v-flex>
        <v-flex class="pl-0 pt-1">
          <span
            class="caption"
          >
            {{ $t('The "Ignore Shipping Type" switch determines whether the taxes should take into account of what type shipping method is. When this switch is enabled, shipping method type will be ignored and tax calculation will be based on the source setting. When this switch is not enabled, then any order with shipping of "Pick Up" type will get its taxes calculated based on "origin" (store address), not the destination (shipping address).') }}
          </span>
        </v-flex>
      </v-flex>
      <v-flex
        xs12
        md6
      >
        <v-card
          flat
          class="pa-3"
        >
          <v-select
            v-model="settings.tax_based_on_source"
            :disabled="settings.type !== 'sales'"
            :items="['origin', 'destination']"
            :label="$t('Based on source:')"
            outline
          />
          <v-switch
            v-model="settings.ignore_shipping_type"
            :label="$t('Ignore Shipping Type')"
            :disabled="settings.type !== 'sales'"
            class="mt-0"
          />
          <v-btn
            :disabled="settings.type !== 'sales'"
            @click="updateSales"
          >
            {{ $t('Update') }}
          </v-btn>
        </v-card>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import TaxMixin from './TaxesMixin'

export default {
  name: 'Settings',

  mixins: [TaxMixin],

  props: {
    settings: {
      type: Object,
      required: true
    }
  },

  methods: {
    updateGeneral () {
      this.$emit('updated', {
        type: this.settings.type,
        discount_after_tax: this.settings.discount_after_tax
      })
    },

    updateVat () {
      this.$emit('updated', {
        vat_in_price: this.settings.vat_in_price
      })
    },

    updateSales () {
      this.$emit('updated', {
        tax_based_on_source: this.settings.tax_based_on_source,
        ignore_shipping_type: this.settings.ignore_shipping_type
      })
    }
  }
}
</script>
